<template>
  <v-container fluid grid-list-xl class="mt-1 pt-0">
    <v-layout wrap>
      <v-flex xs12 lg8 offset-lg2>
        <v-card>
          <v-card-title class="ma-0 pt-0 pb-0 primary--text">
            <h3 class="ma-3">{{ $t('i18n.pagetitle') }}</h3>
          </v-card-title>
          <v-container fluid grid-list-xl class="mt-0 pt-0">
            <v-layout wrap>
              <v-flex xs4 class="pb-0 mb-0 ml-4">
                <v-text-field :label="$t('i18n.filter')" v-model="filter"></v-text-field>
              </v-flex>
              <v-flex xs4 md2 class="pb-0 mb-0 ml-4">
                <v-text-field :label="$t('i18n.filterLang')" v-model="filterLang"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <autotable
                  keyfield="ukey"
                  :columns="columns"
                  :rows="getTranslationsWithkey"
                  @newrow="addT"
                  @change="updateT"
                  :delete="translationdelete"
                  @delete="deleteT"
                  dialogtitle="i18n.createdialog"
                ></autotable>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import Autotable from "../common/autotable/Autotable.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import store from "@/store/";
import VueI18n from "../../i18n.js";

export default {
  components: {
    autotable: Autotable
  },
  data() {
    return {
      filter: undefined,
      filterLang: undefined,
      translationdelete: {
        title: "i18n.deletetitle",
        text: "i18n.deletetext",
        fun: (t => {
          this.$log.debug("DELETE TRADUZIONE-1: ", t);
          this.$log.debug("DELETE TRADUZIONE-2: ", this);
          let name = `<b>${t.key}</b> [${t.lang}]`;
          return { name };
        }).bind(this)
      },
      columns: [
        {
          text: this.$t("admin.i18n.key"),
          value: "key",
          inputtype: "TEXT",
          maxlength: 50,
          required: true,
          readonly: true
        },
        {
          text: this.$t("i18n.lang"),
          value: "lang",
          inputtype: "TEXT",
          maxlength: 2,
          required: true,
          readonly: true
        },
        {
          text: this.$t("i18n.value"),
          value: "value",
          inputtype: "TEXT",
          maxlength: 250,
          required: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getAdminTranslations"]),
    getTranslationsWithkey() {
      let twk = this.getAdminTranslations.map(t => {
        t.ukey = `${t.key}-${t.lang}`;
        return t;
      });
      if (this.filter) {
        twk = twk.filter(t => t.value.toLowerCase().includes(this.filter.toLowerCase() || t.key.toLowerCase().includes(this.filter.toLowerCase())));
      }
      if (this.filterLang) {
        twk = twk.filter(t => t.lang.includes(this.filterLang));
      }
      return twk;
    }
  },
  methods: {
    ...mapActions([
      "doLoadTranslations",
      "doCreateTranslation",
      "doUpdateTranslation",
      "doDeleteTranslation"
    ]),
    ...mapMutations(["mShowLongLoader", "mHideLongLoader", "mShowInfoMessage"]),
    addT(t) {
      this.$log.debug("addT", t);
      this.doCreateTranslation(t);
    },
    updateT(t) {
      this.$log.debug("UpdateT", t);
      this.doUpdateTranslation(t);
    },
    deleteT(t) {
      this.$log.debug("deleteT", t);
      this.doDeleteTranslation(t);
    }
  },
  async beforeRouteEnter(to, from, next) {
    Vue.$log.info("AdminI18N: BEFORE ROUTE ENTER");
    store.commit("mShowLongLoader", VueI18n.t("common.pleasewait"));
    await store.dispatch("doLoadTranslations")
    next();
  }
};
</script>

<style>
</style>